//include 10
jQuery(function(){

    var privateFunctions = {
        disable(component){
            component.find("select").each(function(){
                $(this).prop("disabled",true);
            });
            component.data("disabled",true);
            component.addClass("hide");
        },
        enable(component){
            component.removeClass("hide");
            component.data("disabled",false);
            component.find("select").each(function(){
                $(this).prop("disabled",false);
            });            
        },
        change(component,number){
            var disabled = component.data("disabled");
            if(!!disabled)
                return;
            
            component.find(".control").addClass("hide");
            component.find("select").prop("disabled",true);
            
            for(var i=1;i<= number;i++){
                var control = component.find(`.belegung-row-${i}`);
                if(control.length > 0){
                    control.removeClass("hide");
                    control.find("select").prop("disabled",false);
                }
            }
        },
        get(component){
            var result = [];
            component.find(".control").each(function(){
                var $this = $(this);
                var adults = $this.find("select.adults-select").val();
                var kid1 = $this.find("select.kid1-select").val();
                var kid2 = $this.find("select.kid2-select").val();
                var kid3 = $this.find("select.kid3-select").val();
                var kid4 = $this.find("select.kid4-select").val();               

                var kids = 0;
                var ages = {};

                var agesArray = [];

                if(!isNaN(kid1) && kid1 != "" && kid1 >= 0){
                    //ages.kid1 = kid1;
                    agesArray.push(kid1);
                    //kids++;
                }
                if(!isNaN(kid2) && kid2 != "" && kid2 >= 0){
                    //ages.kid2 = kid2;
                    agesArray.push(kid2);
                    //kids++;
                }
                if(!isNaN(kid3) && kid3 != "" && kid3 >= 0){
                    //ages.kid3 = kid3;
                    agesArray.push(kid3);
                    //kids++;
                }
                if(!isNaN(kid4) && kid4 != "" && kid4 >= 0){
                    //ages.kid4 = kid4;
                    agesArray.push(kid4);
                    //kids++;
                }
                kids = agesArray.length;
                $.each(agesArray,function(index,age){
                    ages['kid'+(index+1)] = age;
                });

                result.push({
                    'adults':adults,
                    'kids':kids,
                    'ages':ages
                });
            });
            return result;
        },
        set(component,index,visitors){
            var control = component.find(`.control.belegung-row-${index}`);
            if(control.length == 0)
                return;
            
            component.data("suppress-change-event",true);

            if(!!visitors && !!visitors.adults){
                control.find("select.adults-select").val(visitors.adults).trigger("change");
            }
            else{
                control.find("select.adults-select").val("").trigger("change");
            }
            if(!!visitors && !!visitors.ages && visitors.ages.hasOwnProperty('kid1') && !isNaN(visitors.ages.kid1)){
                control.find("select.kid1-select").val(visitors.ages.kid1).trigger("change");
            }
            else{
                control.find("select.kid1-select").val("").trigger("change");
            }
            if(!!visitors && !!visitors.ages && visitors.ages.hasOwnProperty('kid2') && !isNaN(visitors.ages.kid2)){
                control.find("select.kid2-select").val(visitors.ages.kid2).trigger("change");
            }
            else{
                control.find("select.kid2-select").val("").trigger("change");
            }
            if(!!visitors && !!visitors.ages && visitors.ages.hasOwnProperty('kid3') && !isNaN(visitors.ages.kid3)){
                control.find("select.kid3-select").val(visitors.ages.kid3).trigger("change");
            }
            else{
                control.find("select.kid3-select").val("").trigger("change");
            }
            if(!!visitors && !!visitors.ages && visitors.ages.hasOwnProperty('kid4') && !isNaN(visitors.ages.kid4)){
                control.find("select.kid4-select").val(visitors.ages.kid4).trigger("change");
            }
            else{
                control.find("select.kid4-select").val("").trigger("change");
            }

            component.data("suppress-change-event",false);
        }
    }

    window.pixelpoint.ppComponents.belegung = function($this){
        //var $this = $(this);
        var eventsPostfix = $this.data("events-postfix");
        if(!eventsPostfix)
            return;

        $this.on("change",".belegung-row-1 select",function(){

            if(!!$this.data("suppress-change-event")){
                return;
            }

            if(!!$this.data("disabled"))
                return;
            var visitors = privateFunctions.get($this);
            if(visitors.length == 0)
                return;
            window.pixelpoint.pubSub.publish(`${window.pixelpoint.pubSub.events.belegungChange}:${eventsPostfix}`,[visitors[0]]);
        });

        window.pixelpoint.pubSub.subscribe(`${window.pixelpoint.pubSub.events.slidersEventEnable}:${eventsPostfix}`,function(){
            privateFunctions.enable($this);
        });
        window.pixelpoint.pubSub.subscribe(`${window.pixelpoint.pubSub.events.slidersEventDisable}:${eventsPostfix}`,function(){
            privateFunctions.disable($this);
        });
        window.pixelpoint.pubSub.subscribe(`${window.pixelpoint.pubSub.events.slidersEventChange}:${eventsPostfix}`,function(e,value){
            privateFunctions.change($this,value);           
        });
        window.pixelpoint.pubSub.subscribe(`${window.pixelpoint.pubSub.events.belegungChange}:inverse:${eventsPostfix}`,function(e,visitors){
            privateFunctions.set($this,1,visitors);           
        });      
    }
    

    $(".belegung-component").each(function(){
        window.pixelpoint.ppComponents.belegung($(this));    
    });

});